// Externe Bibliotheken
import React, { Component } from 'react';

// Styles
import './claimMinutePicker.scss';

class ClaimMinuteField extends Component {
    state = {
        formatedValue: '',
    };

    constructor(props) {
        super(props);

        this.state.args = props.args;

        this.InputTextField = this.InputTextField.bind(this);
    }

    autoformatMinuteHandler(event) {
        let $this = this;
        let e = event;
        if (e.key === 'Backspace' || e.key === 'Delete') {
            return false;
        }

        e.persist();

        function format(target) {
            let output = target;

            // hours
            if (target.length === 2) {
                output = target + ' Std. ';
            }

            // minutes
            if (target.length === 9) {
                let lastIndex = target.charAt(target.length - 1);
                if (!isNaN(lastIndex) && lastIndex > 5) {
                    output = target.slice(0, 8);
                }
            }

            if (target.length === 10) {
                output = target + ' Min.';
            }

            return output;
        }

        setTimeout(function () {
            $this.setState((state) => {
                state.args.answer.formatedValue = format($this.state.args.answer.formatedValue);
                return state;
            });
        }, 0);
    }

    InputTextField(args) {
        let answer = this.state.args.answer;
        let question = this.state.args.question;
        let treeKey = this.state.args.treeKey;

        function PlaceholderHelper() {
            if (args.input.formatedValue === undefined) {
                args.input.formatedValue = '';
            }
            let inputLength = args.input.formatedValue.length;

            let placeholder = '<span class="hide">' + args.input.formatedValue + '</span>';
            if (
                inputLength === 2 ||
                inputLength === 3 ||
                inputLength === 7 ||
                inputLength === 8 ||
                inputLength === 10 ||
                inputLength === 11
            ) {
                placeholder += '<span>&nbsp;</span>';
            }
            placeholder += '00 Std. 00 Min.'.slice(inputLength);

            return (
                <div
                    className="placeholder-helper"
                    onClick={() => {
                        document.querySelector('#' + treeKey + '_' + question.key + '_' + answer.key).focus();
                        return false;
                    }}
                    dangerouslySetInnerHTML={{ __html: placeholder }}></div>
            );
        }

        return (
            <div className="time-selection-input">
                <input
                    name={treeKey + '_' + question.key + '_' + answer.key}
                    id={treeKey + '_' + question.key + '_' + answer.key}
                    value={answer.formatedValue || ''}
                    className={this.props.className}
                    maxLength={15}
                    onKeyDown={(event) => {
                        this.autoformatMinuteHandler(event, answer.formatedValue);
                    }}
                    onChange={(event) => {
                        this.props.handleAnswerInputChange(event, this.state.args);
                    }}
                />
                <PlaceholderHelper />
            </div>
        );
    }

    render() {
        return <this.InputTextField input={this.props.args.answer} />;
    }
}

export default ClaimMinuteField;
